import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const Wrapper = styled.div`
  margin-bottom: 16px;

  @media (${mediaQuery.tablet}) {
    padding-left: 16px;
    padding-right: 16px;
  }
  ${media.lg`
    padding-left: 20px;
    padding-right: 20px;
  `};
`;
export const Header = styled.h1`
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 24px;
  color: #333f48;
`;

export const BlurbText = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
  color: #333f48;
`;

export const ProjectCountText = styled.p`
  font-size: 18px;
  line-height: 22px;
  color: #333f48;
  margin-bottom: 0;
  margin-right: 16px;
  flex-grow: 1;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MobileFiltersButton = styled.div`
  padding: 8px 50px 8px 16px;
  background: #ffffff;
  border: 1px solid #d2d5da;
  border-radius: 3px;
  position: relative;
`;

export const FilterButtonIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 14px;
`;
